/* eslint-disable object-curly-newline */
const dropdownOptions = [
  { id: 1, type: 'Title', value: 'Title', transKey: 'advSearchTitle' },
  { id: 2, type: 'Author', value: 'Author', transKey: 'advSearchAuthor' },
  { id: 3, type: 'Keywords', value: 'Keywords', transKey: 'advSearchKeywords' },
  { id: 4, type: 'Abstract', value: 'Abstract', transKey: 'advSearchAbstract' },
  { id: 5, type: 'Evaluation design', value: 'Evaluation design', transKey: 'advSearchEvalDesign' },
  { id: 6, type: 'Evaluation method', value: 'Evaluation method', transKey: 'advSearchEvalMethod' },
  { id: 7, type: 'Publication type', value: 'Publication type', transKey: 'advSearchPubType' },
  { id: 8, type: 'Study type', value: 'Study Type', transKey: 'advSearchStudyType' },
  { id: 9, type: 'Sector', value: 'Sector', transKey: 'advSearchSector' },
  { id: 10, type: 'Region', value: 'Region', transKey: 'advSearchRegion' },
  { id: 11, type: 'Funded by', value: 'Funded by', transKey: 'advSearchFundedBy' },
  { id: 12, type: 'Country', value: 'Country', transKey: 'advSearchCountry' },
  { id: 13, type: 'Primary theme', value: 'Primary theme', transKey: 'advSearchPrimaryTheme' },
  { id: 14, type: 'Equity focus', value: 'Equity focus', transKey: 'advSearchEquityFocus' },
  { id: 15, type: 'Equity dimension', value: 'Equity dimension', transKey: 'advSearchEquityDimension' },
  { id: 16, type: 'Year of publication', value: 'Year of publication', transKey: 'advSearchYearOfPub' },
  { id: 17, type: 'Primary DAC Code', value: 'Primary DAC Code', transKey: 'advSearchPrimaryDac' },
  { id: 18, type: 'Secondary DAC Code', value: 'Secondary DAC Code', transKey: 'advSearchSecondaryDac' },
  { id: 19, type: 'CRS Voluntary DAC Code', value: 'CRS Voluntary DAC Code', transKey: 'advSearchCrsDac' },
  { id: 20, type: 'UN_SDG', value: 'UN_SDG', transKey: 'advSearchUnSdg' },
  { id: 21, type: 'Primary Dataset Availability', value: 'Primary Dataset Availability', transKey: 'advSearchPriDataset' },
  { id: 22, type: 'Interventions', value: 'Interventions', transKey: 'advSearchInterventions' },
  { id: 23, type: 'Outcomes', value: 'Outcomes', transKey: 'advSearchOutcomes' },
  { id: 24, type: 'Registration', value: 'Pre Registration', transKey: 'advSearchRegistration' },
];

export default dropdownOptions;
